module.exports = [
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/4e463e5cabf12fc0e085272abc1c1703",
		"active": true,
		"name": "Dave Wilner",
		"title": "VP of Sales",
		"quote": "Revenue Leader. Team builder. 80s music master."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/c38c5f8f9decc46a0c61a2db3243dd2c?s=200",
		"active": true,
		"name": "Andrew Johnson",
		"title": "Sales System Administrator",
		"quote": "Salesforce.com Mage from the Upper Left Coast of the USA."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5a6d24cf3085ee2cd46a3ad9304b95e0?s=200",
		"active": true,
		"name": "Jordan Chandler",
		"title": "UK & EMEA, Account Development Representative",
		"quote": "Live, Love, Learn & Laugh."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/397f3a7617bc4bd8ab17888648c06f7a?s=200",
		"active": true,
		"name": "Paul Homer",
		"title": "Director of Sales Operations",
		"quote": "Fixing what's broke and improving what ain't."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2c7f6c3eb78ec893ade69318ed26e5b5",
		"active": true,
		"name": "Nelly Delgado",
		"title": "Customer Onboarding Manager",
		"quote": "Jogger, soccer mom, dog lover."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/2011ea0d651fbbd565c0b03501fbf75d?s=200",
		"active": true,
		"name": "James Bang",
		"title": "Marketing Operations Manager",
		"quote": "Marketing automation. Clean design. Ex-ESP. Acai bowls."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/d898527531aa4dc2111f86a2a7da8f77?s=80",
		"active": true,
		"name": "Kevin Kowalkowski",
		"title": "Enterprise Account Manager",
		"quote": "New Sales, Dad, Soccer Coach, Goal: Get into the shape I was in in college."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/27396b3fa24389198ef5d3e7e410e9c4?size=200",
		"active": false,
		"name": "Ricardo Rauch",
		"mail": "ricky@auth0.com",
		"title": "Head of Design",
		"quote": "Designer / Developer. He previously contributed to OSS projects. Sketch, Pug (Jade) & Stylus.",
		"social": {
			"twitter": "https://twitter.com/rickyrauch",
			"git": "https://github.com/rickyrauch",
			"dribble": "https://dribbble.com/rickyrauch"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/1c9619a22f32012221bd59296dc9a1a2?size=200",
		"active": true,
		"name": "Damian Schenkelman",
		"title": "Engineer",
		"quote": "Backend Ranger. Asado Advocate. Joke Teller. Human Reverse Proxy.",
		"social": {
			"twitter": "https://twitter.com/dschenkelman",
			"git": "https://github.com/dschenkelman"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/75685fa1a59cef5672f0c0c16e260142.png?size=200",
		"active": false,
		"name": "Rodrigo López Dato",
		"title": "Engineer",
		"quote": "I write functional programs and bob my head in odd time signatures.",
		"social": {
			"twitter": "https://twitter.com/rolodato",
			"git": "https://github.com/rolodato"
		}
	},
	{
		"avatarUrl": "https://avatars1.githubusercontent.com/u/655409?v=3&s=460",
		"active": true,
		"name": "Sandrino Di Mattia",
		"mail": "sandrino@auth0.com",
		"title": "Product Owner",
		"quote": "Developer. Father of 3. Microsoft Azure MVP.",
		"social": {
			"twitter": "https://www.twitter.com/sandrinodm"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/5196c6f42d47f5583bbce2120affd4b1?size=200",
		"active": true,
		"name": "Matías Woloski",
		"mail": "matias@auth0.com",
		"title": "Co-Founder, CTO",
		"quote": "Crypto Geek. Culture Maker. Piano Player.",
		"social": {
			"twitter": "https://twitter.com/woloski",
			"git": "https://github.com/woloski"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/df6c864847fba9687d962cb80b482764?size=200",
		"active": true,
		"name": "Martín Gontovnikas",
		"title": "VP of Marketing and Analytics",
		"quote": "Software Engineer at ❤️. Conference speaker 🎙. Read my story at https://gon.to 📚",
		"social": {
			"twitter": "https://twitter.com/mgonto",
			"git": "https://github.com/mgonto"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/53f70144dc9d7c76455fa91f858d4cec?size=200",
		"active": true,
		"name": "Tomasz Janczuk",
		"mail": "tomek@auth0.com",
		"title": "Engineer",
		"quote": "Software - shaken, not stirred. Auth0 via MS (12 years), HP (1/2 years), and 47 Chapters.",
		"social": {
			"twitter": "https://twitter.com/tjanczuk",
			"git": "https://github.com/tjanczuk"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/bb92524137114d812aa1cbbe70d35365?size=200",
		"active": true,
		"name": "Geoffrey Goodman",
		"title": "Engineer",
		"quote": "Creater of Plunker. Self-taught programmer and former Big 4 accountant. Off the beaten path.",
		"social": {
			"twitter": "https://twitter.com/filearts",
			"git": "https://github.com/ggoodman"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/355ebc2fef7f2c3d095887cb2920041f?size=200",
		"active": true,
		"name": "Richard Seldon",
		"mail": "richard.seldon@auth0.com",
		"title": "Customer Success Engineer",
		"quote": "Full-Stack Software Engineer. Consultant.",
		"social": {
			"twitter": "https://www.twitter.com/arcseldon"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/34f27c88555c8c99b965d8137e16bfd9?size=200",
		"active": true,
		"name": "Cristian Douce",
		"mail": "cristian@auth0.com",
		"title": "Engineer",
		"quote": "Javascript Mechanic. Node.js zen-monk. OSS contributor. CDD & HRDD.",
		"social": {
			"twitter": "https://twitter.com/cristiandouce",
			"git": "https://github.com/cristiandouce"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/1329d9e3f4bc1d233788c89c04410bfe.png?size=200",
		"active": true,
		"name": "Victor Fernandez",
		"mail": "victor@auth0.com",
		"title": "Lead Designer",
		"quote": "Design fundamentalist. Hipster developer. Lego assembly line expert.",
		"social": {
			"twitter": "https://twitter.com/vctrfrnndz",
			"git": "https://github.com/vctrfrnndz",
			"dribble": "https://dribbble.com/vctrfrnndz"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/b93af62499ed0f76f280acb37913f15d.png?size=200",
		"active": true,
		"name": "Hernan Zalazar",
		"mail": "hernan@auth0.com",
		"title": "Engineer (Native UX)",
		"quote": "Mobile wizard, jack of all trades. Beer & Football fundamentalist. Scotch aficionado.",
		"social": {
			"twitter": "https://twitter.com/hzalaz",
			"git": "https://github.com/hzalaz"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/5a176c2593d9ec66b998ff09e715821d?size=200",
		"active": true,
		"name": "Daniel Lobo",
		"title": "Developer Success Engineer",
		"quote": "Node.js guy. Runner. Nyctophilic.",
		"social": {
			"twitter": "https://twitter.com/daniw0lf",
			"git": "https://github.com/lobo"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/mark-56b6805207.png",
		"active": true,
		"name": "Mark Olson",
		"title": "VP Finance & Operations",
		"quote": "Compliance. Excel is my middle name."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/6c6e0fc118f7fe998f8621165e147d98?size=200",
		"active": false,
		"name": "Federico Jack",
		"title": "Director of Finance & Operations",
		"quote": "Finance. Operations. Ultramarathon runner.",
		"social": {
			"twitter": "https://twitter.com/fedejack"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/4d44bd6c8bbd97dfeb5e9c299aaa68c5?size=200",
		"active": true,
		"name": "Jose Romaniello",
		"title": "Head Of Engineering",
		"mail": "jose@auth0.com",
		"quote": "Coder. Dad. OSS contributor. Fernet Barista.",
		"social": {
			"twitter": "https://twitter.com/jfroma",
			"git": "https://github.com/jfromaniello"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/yvonne-e6eeb0ffc5.jpg",
		"active": true,
		"name": "Yvonne Wilson",
		"title": "Director of Customer Success",
		"quote": "Identity,  Security, Operational Excellence,  Scaling, Tech Adventurer, Cyclist & Quilter."
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/eugenio-06259616c9.png",
		"active": true,
		"name": "Eugenio Pace",
		"title": "Co-Founder, VP Customer Success",
		"quote": "Electrical engineer. Software practitioner. Amateur mechanic & builder. <3 customers.",
		"social": {
			"twitter": "https://twitter.com/eugenio_pace"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/35b47dce0e2c9ced8b500dca20e1a657.png?size=200",
		"active": true,
		"name": "Benjamín Flores",
		"mail": "benjamin@auth0.com",
		"title": "User Interface Developer",
		"quote": "Dev passionate. Geek toys lover. Capital City hater. All is possible with cheerful music.",
		"social": {
			"twitter": "https://twitter.com/beneliflo_"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jon-68721f2363.png",
		"active": true,
		"name": "Jon Gelsey",
		"title": "CEO",
		"quote": "CEO. Ex-Microsoft. Ex-Intel. Ex-Convex. Designer of super computers.",
		"social": {
			"twitter": "https://twitter.com/jgelsey"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jeremy-be009fa940.png",
		"active": true,
		"name": "Jeremy Jacobs",
		"title": "Director of Sales & Business development",
		"quote": "Expert Developer... of Relationships. CRM/Excel Geek. Hit a homerun at Yankee Stadium."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/43103c16a95db00e7bab1f34d4d6ff8c?size=200",
		"active": true,
		"name": "Sebastian Iacomuzzi",
		"mail": "iaco@auth0.com",
		"title": "Engineer",
		"quote": "Backend Dev from Quemu Quemu, La Pampa. I know what \"Zermatt\" means.",
		"social": {
			"twitter": "https://twitter.com/sebasiaco",
			"git": "https://github.com/siacomuzzi"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/fd8e29ed66618ba98de8e0b09e09c353.png?size=200",
		"active": true,
		"name": "Sebastian Rodriguez Guevara",
		"title": "DevOps Engineer",
		"quote": "Linux lover, former sysadmin. Beatles fan."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d48b998c2dce49ca309710eba498c562.png?s=200",
		"active": true,
		"name": "Nathan Totten",
		"title": "Director of Product Management",
		"quote": "Developer, customer success, learning. Formerly, Microsoft and Iowa.",
		"social": {
			"twitter": "http://twitter.com/ntotten",
			"git": "https://github.com/ntotten"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/48537be253912e7348715f32cd21584b.png?s=200",
		"active": false,
		"name": "Federico Molina",
		"title": "Growth & Analytics",
		"quote": "A little bit of Something.",
		"social": {
			"twitter": "https://www.twitter.com/federicomolina"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/647b1eea820b3fc8a5aee0383930b888.png?size=200",
		"active": true,
		"name": "Pablo Terradillos",
		"mail": "pablo.terradillos@auth0.com",
		"title": "Engineer",
		"quote": "Developer. OSS fan. Half actor and Pokemon trainer.",
		"social": {
			"twitter": "https://twitter.com/tehsis",
			"git": "https://github.com/tehsis"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/667b1c82b6cc2241ff176d50c65da603?size=200",
		"active": true,
		"name": "Eugene Kogan",
		"title": "Head of Security",
		"quote": "Information security engineer. Loves the outdoors, especially mountains.",
		"social": {
			"twitter": "https://twitter.com/eugk",
			"git": "https://github.com/eugk"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jared-0dad95f6ee.png",
		"active": true,
		"name": "Jared Hanson",
		"mail": "jared@auth0.com",
		"title": "Engineer",
		"quote": "Developer of Passport.js and other open source Node.js modules.",
		"social": {
			"twitter": "https://twitter.com/jaredhanson",
			"git": "https://github.com/jaredhanson"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/clayton-2e74b049e9.png",
		"active": true,
		"name": "Clayton Moulynox",
		"title": "Director of Partner Cloud MIS Strategy & Programs",
		"quote": "Technology enabler; status quo challenger; ex-Microsoft; an Aussie - G'day mate!",
		"social": {
			"twitter": "https://twitter.com/claytonhm"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/kelsey-03bbe39096.png",
		"active": false,
		"name": "Kelsey Flittner",
		"title": "Director of marketing and communications",
		"quote": "Brand. Marketing. Communications. I love chocolate. The end.",
		"social": {
			"twitter": "https://twitter.com/kelseyoneal"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/german-3aa35d2747.png",
		"active": true,
		"name": "Germán Lena",
		"mail": "german@auth0.com",
		"title": "Engineer",
		"quote": "Love to make things. OSS, data analysis and visualization fan. Surf enthusiast.",
		"social": {
			"twitter": "https://twitter.com/german_lena",
			"git": "https://github.com/glena"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/da735b48d8300a97640149156b650305.png?size=200",
		"active": true,
		"name": "Luciano Balmaceda",
		"mail": "luciano.balmaceda@auth0.com",
		"title": "Mobile Engineer",
		"quote": "NodeJS & Android Developer. I love to home brew beer and even enjoy consuming them!",
		"social": {
			"twitter": "https://twitter.com/balmalucho",
			"git": "https://github.com/lbalmaceda"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/erin-d40dff3040.png",
		"active": true,
		"name": "Erin Staeger",
		"title": "HR Manager",
		"quote": "Human Resources, Ex-Accountant, Amateur Interior Designer, Dog Lover."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/3f695f9558dd12d86a90dbc59b284f9b.png?size=200",
		"active": true,
		"name": "Leonardo Helman",
		"title": "DevOps Engineer",
		"quote": "Developer. Sysadmin. Technical. Pilot.",
		"social": {
			"git": "https://github.com/lhelman"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/8541998714e3047fb0e52422ba8dff13.png?size=200",
		"active": true,
		"name": "Peter Stromquist",
		"title": "Head of Pre-Sales Engineering",
		"quote": "Family man. Fixed-gear biker. Learn -> Teach -> Learn. Minimalist Platforms and Lightweight Frameworks.",
		"social": {
			"twitter": "https://twitter.com/twistedstream",
			"git": "https://github.com/twistedstream"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/7d590747a0cd8e24a4c86dd5fd9990ef?size=200",
		"active": true,
		"name": "Hernán Tierno",
		"mail": "hernan.tierno@auth0.com",
		"title": "Engineer",
		"quote": "Passionate Software Developer. Love simple solutions and the Unix Philosophy.",
		"social": {
			"twitter": "https://twitter.com/hernanhht",
			"git": "https://github.com/hernanhht"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/05a4170856a6157f81319595e42fdc5b?size=200",
		"active": false,
		"name": "Gabriel Andretta",
		"mail": "gabriel@auth0.com",
		"title": "Engineer",
		"quote": "I like programming languages where parens hug the code.",
		"social": {
			"twitter": "https://twitter.com/gnandretta",
			"git": "https://github.com/gnandretta"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/bb9128fac91692ad4f46a785d772dd39?s=200",
		"active": true,
		"name": "Pablo Seibelt",
		"title": "Data Scientist",
		"quote": "Software Developer, Data Science Specialist & Otaku. Mate and Chipá advocate.",
		"social": {
			"twitter": "https://twitter.com/sicarul",
			"git": "https://github.com/sicarul"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/73beae90bfcfea6bb084d34120e8b9cf?size=200",
		"active": false,
		"name": "Chris Keyser",
		"mail": "chris@auth0.com",
		"title": "Product Owner, Appliance",
		"quote": "Coder. Navy nuke. Harley rider. Lousy golfer.",
		"social": {
			"twitter": "https://twitter.com/chriskeyser"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/977b4137e1b2dd12d168726ede712b68?size=200",
		"active": true,
		"name": "Martin Cabral",
		"mail": "martin.cabral@auth0.com",
		"title": "Engineer",
		"quote": "Code writer. Music Lover. Tennis player wannabe.",
		"social": {
			"twitter": "https://twitter.com/mcabral_",
			"git": "https://github.com/cabralmartin"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2e8f0e9220f907fba93b524a25bdffcb?s=200",
		"active": true,
		"name": "Federico Otero",
		"title": "Data Engineer",
		"quote": "Data engineer, reporting specialist. Guitar Hero."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/ef8017f9c3c5a3264839361d977adcce?s=200",
		"active": true,
		"name": "Tomás Chernov",
		"mail": "tomas.chernov@auth0.com",
		"title": "Front End Developer",
		"quote": "Front end coder, 60fps animations mandatory. Arts enthusiast, tennis lover.",
		"social": {
			"twitter": "https://twitter.com/Shernzs",
			"git": "https://github.com/cherna"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/55ef468c3f2e7394bf451245f59747a5?s=200",
		"active": false,
		"name": "Matthew Durkin",
		"title": "Business Development",
		"quote": "Builds business relationships, empathy for developers, U.S.C.G. Licensed Captain."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/20b7b6bd9a774a96a627324fbc7ebdd7.png?s=200",
		"active": false,
		"name": "Matias Lopez Riglos",
		"title": "DevOps Engineer",
		"quote": "Sysadmin. Linux fan. Husband and father of 2. Futbol as a way of life",
		"social": {
			"git": "https://github.com/mflopez79"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/2b1e18889a07b55e88b518dca0013bd6.png?s=200",
		"active": true,
		"name": "Soledad Pano",
		"title": "Customer Success Engineer",
		"quote": "Full time mother of 2. I enjoy working as a software engineer in my \"spare time\"",
		"social": {
			"twitter": "https://twitter.com/solepano",
			"git": "https://github.com/solepano"
		}
	},
	{
		"avatarUrl": "https://0.gravatar.com/avatar/a1c61dfb3670fa0617364f5179cc13b0.png?s=200",
		"active": true,
		"name": "Damian Fortuna",
		"mail": "damian.fortuna@auth0.com",
		"title": "Front End Developer",
		"quote": "Love coding, running and fixing (actually breaking) things :).",
		"social": {
			"twitter": "https://twitter.com/damifortu"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/4206d30af383e56fb15aa27523c84ac1.png?s=200",
		"active": true,
		"name": "Diego Poza",
		"title": "Head of Content Marketing",
		"quote": "Systems Engineer from Corrientes. Geek. Writer. Speaker. Foodie. Gamer.",
		"social": {
			"twitter": "https://twitter.com/diegopoza",
			"git": "https://github.com/diegopoza"
		}
	},
	{
		"avatarUrl": "https://1.gravatar.com/avatar/7f4ec37467f2f7db6fffc7b4d2cc8dc2?s=250",
		"active": true,
		"name": "Ryan Chenkie",
		"title": "Product Owner",
		"quote": "Coder, guitar player, space nerd. Always learning and teaching what I know.",
		"social": {
			"twitter": "https://twitter.com/ryanchenkie",
			"git": "https://github.com/chenkie"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/56776a9dcc25e1f03aa3124cfc99df01.jpg?s=80",
		"active": true,
		"name": "Valeria Fugante",
		"title": "Accounting Manager",
		"quote": "Accounting Manager. Music and summer lover"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/casas-c7460ec106.png",
		"active": true,
		"name": "Pablo Casas",
		"title": "Data Scientist",
		"quote": "Machine Learning Specialist, helping numbers to be alive."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/9d676c69f64d4b955dc14e1e8e85ca15?s=80",
		"active": true,
		"name": "Andrew Aviña",
		"title": "Inside Sales Executive",
		"quote": "Customer shepherd. Sports & software enthusiast. Movie quotes make up 95% of my humor."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ca578185f64251739569feed94986612?s=80",
		"active": true,
		"name": "Silvio Massari",
		"mail": "silvio.massari@auth0.com",
		"title": "Engineer",
		"quote": "Backend Dev. Dad and sailboat enthusiast."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/3b02263f5a5cb404c187f0d3f2dbbb19?s=80",
		"active": true,
		"name": "Bárbara Muñoz Cruzado",
		"title": "UI/UX Designer",
		"quote": "UI/UX Designer. Fashion Designer wannabe. Master of cooking since 1992"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/b1a976f8c9a0c7524e8bae1d6181ca05.jpg?s=80",
		"active": true,
		"name": "Hernán Meydac Jean",
		"title": "Release Manager",
		"quote": "Developer and starving writer. Dark side programmer. The answer is 42.",
		"social": {
			"twitter": "https://twitter.com/verlicredclaw",
			"git": "https://github.com/verlic"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/96298957/4431e03ec06ea68cd3f48f34016f8186.jpeg?s=80",
		"active": true,
		"name": "Liqin Mo",
		"title": "Controller",
		"quote": "CPA. Ex ME major."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/6e9c8a65f5b0f9bb57c53cdc40feecac.jpg?s=200",
		"active": true,
		"mail": "marcos.castany@auth0.com",
		"name": "Marcos Castany",
		"title": "Engineer",
		"quote": "Dev, Rugby Player, Asado fan",
		"social": {
			"twitter": "https://twitter.com/totus_hits",
			"git": "https://github.com/mcastany"
		}
	},
	{
		"avatarUrl": "https://es.gravatar.com/userimage/20584812/aa6c2ef56cd36ad3bc497ef8d39ec2f9.jpg",
		"active": true,
		"name": "Yohanna Etchemendy",
		"mail": "yohanna.etchemendy@auth0.com",
		"title": "Product Designer",
		"quote": "Designholic, Dinosaur enthusiast, Karaoke evangelist.",
		"social": {
			"twitter": "https://twitter.com/0xbunny",
			"git": "https://github.com/yohannaje",
			"dribble": "a(href=\"https://dribbble.com/0xbunny\", target=\"_blank\")"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/e5fdabb1d3e1e9e1f1dce56a7175be3e?s=80",
		"active": true,
		"name": "Keith Galloway",
		"title": "Customer Success Engineer",
		"quote": "Create - Break - Fix - Note - Repeat | Practicing the art of Rhythmically Applied Poetry"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/bc94ff6211e645a2bdb4fdc60e23ad85.jpg?s=200",
		"active": false,
		"name": "Kassandra Perch",
		"title": "Developer Evangelist",
		"quote": "Robotics Fanatic. Cat lover. Video Game player. GIF connoisseur.",
		"social": {
			"twitter": "https://twitter.com/nodebotanist",
			"git": "https://github.com/nodebotanist"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/a5878db74baa36ad0ae9cda759f9f2f8.jpg?s=200",
		"active": true,
		"name": "Javier Centurion",
		"mail": "javier.centurion@auth0.com",
		"title": "Engineer",
		"quote": "Developer. Music lover.",
		"social": {
			"twitter": "https://twitter.com/jcenturion86",
			"git": "https://github.com/jcenturion"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/7d41c3b038d67898247bff3e462c42a5?s=200",
		"active": true,
		"name": "Zulfiqar Ahmed",
		"title": "Customer Success Engineer",
		"quote": "Developer, consultant & an eager learner. Ex-Microsoft consultant.",
		"social": {
			"twitter": "https://twitter.com/zahmed",
			"git": "https://github.com/zamd"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/af23b64b853de5ae600f4d6aef7c14e0?s=200",
		"active": true,
		"name": "Alejo Fernandez",
		"title": "Engineer",
		"quote": "Full-stack Javascript developer, continuous learner, amateur cyclist, retired DJ, music lover.",
		"social": {
			"twitter": "https://twitter.com/djseika",
			"git": "https://github.com/alejofernandez"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5c3fd6858cdd6b3c924d1eccb465ee02?s=200",
		"active": true,
		"name": "Ramiro Silveyra d'Avila",
		"title": "Front End Engineer",
		"quote": "Developer, Web lover.",
		"social": {
			"twitter": "https://twitter.com/ramasilveyra",
			"git": "https://github.com/ramasilveyra"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/fa31036c556714acc4a48420117df37f?s=200",
		"active": false,
		"name": "Ignacio Esmite",
		"title": "Engineer",
		"quote": "Software Engineer, enjoy to make things happen and learn new things. Sports lover.",
		"social": {
			"twitter": "https://twitter.com/NachoEsmite",
			"git": "https://github.com/nachoesmite"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/6222081fd7dcea7dfb193788d138c457?s=200",
		"active": true,
		"name": "Jerrie Pelser",
		"title": "Engineer",
		"quote": "Software developer and world traveler.",
		"social": {
			"git": "https://github.com/jerriep"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/09951bbb702cfdad0e1ce7b82dd9a637?s=200",
		"active": true,
		"name": "Nicolas Ulrich",
		"mail": "nicolas.ulrich@auth0.com",
		"title": "Mobile Engineer",
		"quote": "Computer Engineer, open source advocate, electronics and robotics fanatic, tennis player wannabe.",
		"social": {
			"twitter": "https://twitter.com/nikolaseu",
			"git": "https://github.com/nikolaseu"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ea03ba48f7041d9bf675a067806d9d76?size=200",
		"active": true,
		"name": "Dirceu Pereira Tiegs",
		"title": "Engineer",
		"quote": "Developer, book lover, FPS noob.",
		"social": {
			"twitter": "https://twitter.com/dirceu",
			"git": "https://github.com/dirceu"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d8acebfee13c5fe4617dbf77c7058838?size=200",
		"active": true,
		"name": "Nicolas Plessis",
		"title": "Site Reliability Engineer",
		"quote": "DevOps enthusiast, cook, homebrewer & drummer.",
		"social": {
			"twitter": "https://twitter.com/choopooly",
			"git": "https://github.com/choopooly"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/da0d9774051338cb9a5854baafb2e37d?size=200",
		"active": true,
		"name": "Katherine Horne",
		"title": "Technical Writer",
		"quote": "Avid reader, knitter, doer of the New York Times Crossword Puzzles",
		"social": {
			"git": "https://github.com/khorne3"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/bb00217fba01f33cd0d12001f8f4d10f?size=200",
		"active": true,
		"name": "Vikas Jayaram",
		"title": "Developer Success Engineer",
		"quote": "Developer, Cricketer & keen learner.",
		"social": {
			"git": "https://github.com/vikasjayaram"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/3809/7b7ede19b802e02bb4320ea329ae40f2.png?size=200",
		"active": true,
		"name": "Peter Filias",
		"title": "Customer Success Manager",
		"quote": "Gamer, Father of 2, Snowboarder, Mountain Biker, Occasional Runner, Baseball Coach, Scout Leader, Lecturer",
		"social": {
			"twitter": "https://twitter.com/pfilias"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/a403bd0d4d1de0cc57239c416821bb88?size=200",
		"active": true,
		"name": "Mariano Szklanny",
		"title": "Engineering Ops Manager",
		"quote": "Geek, ex-developer, and MBA. Love driving, photography, & music."
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/30146472/88a7c03f7ed5a84757a2799332b7b0de.jpg?size=200",
		"active": true,
		"name": "Ado Kukic",
		"title": "Technical Writer",
		"quote": "VR Enthusiast, Writer, Developer, Teacher, Learner, Gopher",
		"social": {
			"twitter": "https://twitter.com/kukicadnan",
			"git": "https://github.com/kukicadnan"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/20807150/4deb2db17135af46f17d5cda3b58fd0d.png?size=200",
		"active": true,
		"name": "Kim Maida",
		"title": "Technical Writer",
		"quote": "Geek, Mother, Biologist, UI Engineer, Open Sourceror. Loves hiking, cooking, & reading.",
		"social": {
			"twitter": "https://twitter.com/KimMaida",
			"git": "https://github.com/kmaida"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/11032473/d9733dd84d700fefe0161c919e39b245.jpg?size=200",
		"active": false,
		"name": "James Fryman",
		"title": "Infrastructure Product Owner",
		"quote": "Technologist, Entrepreneur, Hacker and General Human. Searching for the meaning of life through science and technology.",
		"social": {
			"twitter": "https://twitter.com/jfryman",
			"git": "https://github.com/jfryman"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/5dbe52812be440138ca34a4dc8bc80c0?s=200",
		"active": true,
		"name": "Alex Stanciu",
		"mail": "alex@auth0.com",
		"title": "Product Owner",
		"quote": "Drinking the digital wine, dancing the electric boogaloo.",
		"social": {
			"twitter": "https://twitter.com/alecks",
			"git": "https://github.com/astanciu"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/102088726/e196809fe9c28d08da3b2bf526b41847.jpg?size=200",
		"active": true,
		"name": "Don Vaughn",
		"mail": "don.vaughn@auth0.com",
		"title": "Enterprise Account Executive",
		"quote": "Techie sales guy, big company refugee, music fan and music man",
		"social": {
			"twitter": "https://twitter.com/donvaughn"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/71313b369e8f23b7ec7b4614acdf3031.png?size=200",
		"active": true,
		"name": "Radosław Karpowicz",
		"mail": "radekk@auth0.com",
		"title": "Security Engineer",
		"quote": "Developer and security guy. Loves snowboarding and his Kawasaki bike.",
		"social": {
			"twitter": "https://twitter.com/radekk",
			"git": "https://github.com/radekk"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/102719873/125879486644022583b8d27e88a8e7d5.jpg?size=200",
		"active": true,
		"name": "Angela Lazar",
		"mail": "angela.lazar@auth0.com",
		"title": "Technical Writer",
		"quote": "Craft enthusiast, music lover, cat whisperer",
		"social": {
			"git": "https://github.com/angelaLazar"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/7db3b1488c23b208fd5b7b38498bc6d1.png?size=200",
		"active": true,
		"name": "Ashish Dasnurkar",
		"title": "Developer Success Engineer",
		"quote": "JavaScripter. Loves family, street photography, hiking, running, coffee and helping others",
		"social": {
			"git": "https://github.com/ashishdasnurkar",
			"twitter": "https://twitter.com/AshishDasnurkar"
		}
	},
	{
		"avatarUrl": "https://0.gravatar.com/avatar/c5562e4ad0d488fb4d8e1ab8819027d1?size=200",
		"active": true,
		"name": "Robert Rexford",
		"title": "Sales Engineer",
		"quote": "I miss my Amiga.",
		"social": {
			"git": "https://github.com/rrexford"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ee6fb8eb6b74f00f5324410a01f1f97e?s=200",
		"active": true,
		"name": "Prashant Trivedy",
		"title": "Developer Success Engineer",
		"quote": "Actively active in activities...and sleep.",
		"social": {
			"twitter": "https://twitter.com/mrprashantt"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/e42511d0034e0f3936941867ebdd8aea?s=200",
		"active": true,
		"name": "Bob Brumfield",
		"mail": "bob.brumfield@auth0.com@auth0.com",
		"title": "Engineer",
		"quote": "Coder, recovering Windows user, looking for next cup of coffee.",
		"social": {
			"twitter": "https://twitter.com/bobbrum"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d39ab281a5d166f71b97062a7d0d4f38?s=200",
		"active": true,
		"name": "Ariel Gerstein",
		"title": "Front end Developer",
		"quote": "Developer. Love Javascript and the web.",
		"social": {
			"twitter": "https://twitter.com/arielger_",
			"git": "https://github.com/arielger"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/612047918c9324a5b2bf9c3ca72b0110?s=200",
		"active": true,
		"name": "Mauricio Schneider",
		"title": "Developer Success Engineer",
		"quote": "I love fixing things, especially if I broke them in the first place.",
		"social": {
			"twitter": "https://twitter.com/lemavri",
			"git": "https://github.com/lemavri"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/11371420/54f3fecf3ce3bbef2d7a62b4f0496de2.jpg?size=200",
		"active": true,
		"name": "Thameera Senanayaka",
		"title": "Developer Success Engineer",
		"quote": "1x engineer and huge SOAD fan. Life goal: understand monads.",
		"social": {
			"twitter": "https://twitter.com/thameera",
			"git": "https://github.com/thameera"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/fb206ce598852363e610e68b28cdf10a?s=200",
		"active": true,
		"name": "Germán Matosas",
		"title": "Director of Customer Success, Solutions Architecture Team",
		"quote": "Computer Engineer, ex-Microsoft, Delivery Excellence, avid learner.",
		"social": {
			"twitter": "https://twitter.com/german_matosas"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/7ecfffd77474e0d1bafa94656d1458e3?s=200",
		"active": true,
		"name": "Paul Leto",
		"title": "Senior Director of Sales",
		"quote": "Passionate sales leader/coach.  Detroit sports lover and travel fanatic."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/4ff2f1955778896cc06318b342dabf55?size=200",
		"active": true,
		"name": "Maria Paktiti",
		"mail": "maria@auth0.com",
		"title": "Technical Writer",
		"quote": "Writer. Reader. Developer. Polymath. Dog Lover. Cannot live away from the sea.",
		"social": {
			"twitter": "https://twitter.com/mariap__",
			"git": "https://github.com/mpaktiti"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2240e74e735061332bff7a37c9c7d9c8?size=200",
		"active": true,
		"name": "Rachael Tiow",
		"title": "Corporate Sales",
		"quote": "Evangelist @Auth0, Microlender @Kiva, Sponsor @ Pencil of Promise, Olympic Weightlifter, Yogi, World Traveler & Humble Warrior.",
		"social": {
			"twitter": "https://twitter.com/rachael_tiow"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/28c9ec2561e35b62fab2820e14d1bf46?size=200",
		"active": true,
		"name": "Hugo Arregui",
		"mail": "hugo.arregui@auth0.com",
		"title": "Engineer",
		"quote": "Developer. Loves coding, linux and books.",
		"social": {
			"git": "https://github.com/hugoArregui"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/87daf4c39b1bded1f7ee5a8b4d4827a9?s=200",
		"active": true,
		"mail": "eduardo.diaz@auth0.com",
		"name": "Eduardo Díaz Sanabria",
		"title": "Engineer",
		"quote": "Software development enthusiast",
		"social": {
			"twitter": "https://twitter.com/ziluvatar",
			"git": "https://github.com/ziluvatar"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/9ccf8645ff4daa837dec9ca6fed6a0de?size=200",
		"active": true,
		"name": "Jason Strutz",
		"mail": "jason.strutz@auth0.com",
		"title": "Engineer",
		"quote": "Abstraction collector.  Hammock-driven developer.  Open web advocate.",
		"social": {
			"git": "https://github.com/jstrutz"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/3d5625c035057aa5e2535f6bf6f3c984?size=200",
		"active": false,
		"name": "Ludovic Henin",
		"title": "Engineer",
		"quote": "Lets get coding!",
		"social": {
			"git": "https://github.com/ludohenin",
			"twitter": "https://twitter.com/Ludohen"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/283ecf52eabc2338f848eb2ba4d21ddc?size=200",
		"active": true,
		"name": "Miguel Casas",
		"title": "Engineer",
		"quote": "Developer and Maker by Pasion!",
		"social": {
			"git": "https://github.com/mike-casas",
			"twitter": "https://twitter.com/neneriostb"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/aad15eb1f96fec318b1075a8c743e770?size=200",
		"active": true,
		"name": "Pushp Abrol",
		"title": "Sales Engineer",
		"quote": "Ex Dev Manager, Enjoy tennis, soccer and cricket ofcourse!",
		"social": {
			"git": "https://github.com/pushpabrol",
			"twitter": "https://twitter.com/pushpabrol"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d70a5ec7c767da9244e702bbfc35e8d8?size=200",
		"active": true,
		"name": "Nicolás Sabena",
		"title": "Developer Success Engineer",
		"quote": "Coder. Father. Amateur pianists. Loves the outdoors, cooking and travelling.",
		"social": {
			"git": "https://github.com/nicosabena"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/e47f591f3ecaf77e1b305926b1813ea4?s=200",
		"active": true,
		"name": "Lucas Crespo",
		"title": "Data Engineer",
		"quote": "Data enthusiast. Traveler. Runner",
		"social": {
			"twitter": "https://twitter.com/LucCrespo"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/625fa32e25fbdd8ca42483f0b9e2756f?size=200",
		"active": true,
		"name": "Abhishek Hingnikar",
		"mail": "abhishek.hingnikar@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Explorer, Browser Fanboy and a Borg Drone",
		"social": {
			"git": "https://github.com/darkyen"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/79a77b32af4483ed74e03b53e1ce578a?size=200",
		"active": true,
		"name": "Sergio Fruto",
		"mail": "sergio.fruto@auth0.com",
		"title": "UI Engineer",
		"quote": "Developer in the making. Technology enthusiast. Movies, series, videogames, sports, dogs. The North Remembers.",
		"social": {
			"git": "https://github.com/sergiofruto"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/19cb9b80e4a76c3930ac3cb8c2f97cd6?size=200",
		"active": false,
		"name": "Sally Lehman",
		"mail": "sally.lehman@auth0.com",
		"title": "Production Engineer",
		"quote": "Developer. Stringer-Together of Things. Happy and still Hungry.",
		"social": {
			"twitter": "https://twitter.com/sllylhmn",
			"git": "https://github.com/rothsa"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/d5365965372e0c5843d836f660b51a84/?size=200",
		"active": true,
		"name": "Jeff Smith",
		"mail": "jeff.smith@auth0.com",
		"title": "Technical Writer",
		"quote": "Developer, writer, reader, tech geek, and forever an amateur tinkerer.",
		"social": {
			"twitter": "https://twitter.com/jeffreylees",
			"git": "https://github.com/jeffreylees"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/f88b270215f1901c4291c1f317f979bc/?size=200",
		"active": true,
		"name": "Prosper Otemuyiwa",
		"mail": "prosper.otemuyiwa@auth0.com",
		"title": "Technical Writer",
		"quote": "Software Developer . Writer . Speaker . Community Builder . Open Sourcerer",
		"social": {
			"twitter": "https://twitter.com/unicodeveloper",
			"git": "https://github.com/unicodeveloper"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/8e5a8216a606127a787669d99de86ee2/?size=200",
		"active": true,
		"name": "Carlos Mostek",
		"mail": "carlos.mostek@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Coder, Family Man (wife and three crazy kids), Soccer Addict (coach and player), Juggler, Gamer, Fun haver",
		"social": {
			"twitter": "https://twitter.com/mostekcm",
			"git": "https://github.com/mostekcm"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/8cdca0cec30a9c736394d143df7a44c2?size=200",
		"active": true,
		"name": "Yamil Asusta",
		"mail": "yamil.asusta@auth0.com",
		"title": "Production Engineer",
		"quote": "Writing and deploying code from a beach in Puerto Rico",
		"social": {
			"twitter": "https://twitter.com/elbuo8",
			"git": "https://github.com/elbuo8"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/36d0024e9a998273f9f5a5986cca232c?size=200",
		"active": true,
		"name": "Samuel Judson",
		"mail": "samuel.judson@auth0.com",
		"title": "Application Security Engineer",
		"quote": "Silently hoping for a constructive P=NP proof.",
		"social": {
			"git": "https://github.com/sjudson-auth0"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/8920d2e0274c7778848cfffcc7873415?s=480",
		"active": true,
		"name": "Annybell Villarroel",
		"mail": "annybell.villarroel@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Electronic Engineer. Software Enthusiast",
		"social": {
			"git": "https://github.com/annyv2"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/e51bcc80714c984d8a1a2a3c572a3467?size=200",
		"active": true,
		"name": "Fredrik Liljegren",
		"mail": "fredrik.liljegren@auth0.com",
		"title": "Engineer",
		"quote": "Hammock Driven Developer 👣",
		"social": {
			"git": "https://github.com/fiddur",
			"twitter": "https://twitter.com/fiddur"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/6215d8cdc86569e007d358589e9ddc76?size=200",
		"active": false,
		"name": "Vinícius Krolow",
		"mail": "vinicius.krolow@auth0.com",
		"title": "Engineer",
		"quote": "Coder and Amateur Fisherman",
		"social": {
			"git": "https://github.com/krolow",
			"twitter": "https://twitter.com/krolow"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2d1384da60898aa1ee6cb7755eaa6a46?size=200",
		"active": true,
		"name": "Alec Pesola",
		"mail": "alec.pesola@auth0.com",
		"title": "Senior IT Support Engineer",
		"quote": "Hip-hop enthusiast, soccer fan, coffee addict",
		"social": {
			"twitter": "https://twitter.com/alecpesola"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5e137b3e18b512c421edf75eb0f6967f/?size=200",
		"active": true,
		"name": "Guillermo Mesyngier",
		"mail": "guillermo.mesyngier@auth0.com",
		"title": "Front End Developer",
		"quote": "UX and design enthusiast. Photography, illustrations, cook and biker.",
		"social": {
			"twitter": "https://twitter.com/gmesyngier",
			"git": "https://github.com/gmesyngier"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/edd4eda6a3c7d2d18e96f5ca1beea6ad?size=200",
		"active": true,
		"name": "Amaan Cheval",
		"mail": "amaan.cheval@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Aspiring serial neophyte. Interested in information security, foreign languages, kernels, compilers, and other fancy sounding things.",
		"social": {
			"twitter": "https://twitter.com/AmaanC",
			"git": "https://github.com/AmaanC"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/94167463a175f9bb522a432acef01351?s=200",
		"active": true,
		"name": "David Patrick",
		"mail": "david.patrick@auth0.com",
		"title": "Customer Success Engineer",
		"quote": "Developer, Dad, Husband, Coffee Lover, Podcast Listener",
		"social": {
			"git": "https://github.com/davidpatrick",
			"twitter": "https://twitter.com/dponrails"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/a7e145a62540d8e63e275c494b235437?s=200",
		"active": true,
		"name": "Rikaard Hosein",
		"mail": "rikaard.hosein@auth0.com",
		"title": "Engineer",
		"quote": "Developer, Security Enthusiast",
		"social": {
			"git": "https://github.com/rikaardhosein",
			"twitter": "https://twitter.com/RikaardHosein"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/c437963c0352e86575808d558736e200?s=200",
		"active": true,
		"name": "Kerry Ok",
		"mail": "kerry.ok@auth0.com",
		"title": "Sr. Director of Demand Generation",
		"quote": "Marketer + Mom who enjoys football [American], poker and games of all types"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/8bf5b1794bd461911ad8f9ec4e364272?s=200",
		"active": false,
		"name": "Carlos Johnson",
		"mail": "carlos.johnson@auth0.com",
		"title": "Engineer",
		"quote": "Programmer by day; maker by night",
		"social": {
			"git": "https://github.com/callemo"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/3586669b65dcba7785e4339684e81ae8?s=80",
		"active": true,
		"name": "Brandon Thompson",
		"mail": "brandon.thompson@auth0.com",
		"title": "Technical Account Manager",
		"quote": "Soccer, Music, Security get me up",
		"social": {
			"git": "https://github.com/BRVNDXN"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/3a5545879176d44b7ee763931ab05a57?size=200",
		"active": true,
		"name": "Justin Hinerman",
		"mail": "justin.hinerman@auth0.com",
		"title": "Product Owner",
		"quote": "Husband, Father, Coder, Drummer, Rush Fanatic. Always learning.",
		"social": {
			"git": "https://github.com/jhiner"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/38abb7da1b5442e52a1937378c2fae4a?s=200",
		"active": true,
		"name": "Glenn Block",
		"mail": "glenn.block@auth0.com",
		"title": "Director of Product Management, Webtask",
		"quote": "Every day is a chance to learn",
		"social": {
			"git": "https://github.com/glennblock",
			"twitter": "https://twitter.com/gblock"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/7659da9aa715766318710486e5f2d239/?size=200",
		"active": true,
		"name": "Shawn Meyer",
		"mail": "shawn.meyer@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Developer, runner, rec soccer all-start, coffee drinker, and family man",
		"social": {
			"git": "https://github.com/sgmeyer",
			"twitter": "https://twitter.com/sgmeyer"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/969c1c39639503981f3887d3965ae801?size=200",
		"active": true,
		"name": "Sandra Karlsson",
		"mail": "sandra.karlsson@auth0.com",
		"title": "Office Manager",
		"quote": "Travel. Hotels. Food. Fitness."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/5bdf34cb56195a699562bb1468013154?s=200",
		"active": false,
		"name": "Kunal Batra",
		"mail": "kunal.batra@auth0.com",
		"title": "Head of Developer Evangelism",
		"quote": "Serving Developers on behalf of Auth0. Swift/Python Dev. Taco Bell Enthusiast.",
		"social": {
			"twitter": "https://twitter.com/kunal732",
			"git": "https://github.com/kunal732"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/ca7459e807cfba8abc50edbe758ee1b4?size=200",
		"active": true,
		"name": "Santiago Rodríguez",
		"mail": "santiago.rodriguez.pozo@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Software engineer, baroque violinist, blockchain enthusiast and mead maker",
		"social": {
			"twitter": "https://twitter.com/santiagorp",
			"git": "https://github.com/santiagorp"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/a20ef7cf54247280dd2191d6c10d16c0?size=200",
		"active": true,
		"name": "Fady Abdel Malik",
		"mail": "fady@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Software Engineer. Always passionately curious. Coffee drinker, DJ, music producer, adventurer, traveller, outdoors lover & arts enthusiast. Scotch, neat please.",
		"social": {
			"git": "https://github.com/FadyMak"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b4fb4083b0bfad7e4726e0b57c8840bc?size=200",
		"active": true,
		"name": "Alfredo Villagómez",
		"mail": "alfredo.villagomez@auth0.com",
		"title": "Engineer",
		"quote": "Javascript Developer",
		"social": {
			"twitter": "https://twitter.com/_alfredovm",
			"git": "https://github.com/alfredov"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/fad941dcdbf2d688be87c8164c85b144?size=200",
		"active": true,
		"name": "Guillermo Rodas",
		"mail": "grodas@auth0.com",
		"title": "Engineer",
		"quote": "I like to learn new things.",
		"social": {
			"twitter": "https://twitter.com/garethderioth",
			"git": "https://github.com/garethderioth"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5e2529582a84c80dcf64c6f56042ad88?size=200",
		"active": false,
		"name": "Juan Pablo Picasso",
		"mail": "jp@auth0.com",
		"title": "Engineer",
		"quote": "Software Engineer. Robotics, AI, Batman!",
		"social": {
			"git": "https://github.com/jotadepicas"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/1b431a32be50c8f1ea8c2297685cf77b?size=200",
		"active": true,
		"name": "Martin Walsh",
		"mail": "martin.walsh@auth0.com",
		"title": "iOS Engineer",
		"quote": "Designer of games, maker of things. Never stop learning and sharing.",
		"social": {
			"twitter": "https://twitter.com/martin64k",
			"git": "https://github.com/cocojoe"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/f60630ead0e8749e4dbd9ea9a99b5cab?size=200",
		"active": true,
		"name": "Saltuk Alakus",
		"title": "Developer Success Engineer",
		"quote": "Searching the meaning of life in my spare time. Have some rough idea at the moment.",
		"social": {
			"git": "https://github.com/saltukalakus"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/862e7c75b0446f991edf8abcb4ef18bf/?size=200",
		"active": true,
		"name": "Sandeep Neerarambham",
		"mail": "sandeep.neerarambham@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Software Engineer, Learner, History Buff, Star Gazer and Family man",
		"social": {
			"git": "https://github.com/sandeepneerarambham",
			"twitter": "https://twitter.com/sandeepneera"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/4bc19d2134494bc311123c184d816a97/?size=200",
		"active": true,
		"name": "Jake Pyne",
		"mail": "jake.pyne@auth0.com",
		"title": "Engineer",
		"quote": "Full-stack developer",
		"social": {
			"git": "https://github.com/okjake",
			"twitter": "https://twitter.com/jakepyne"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/a7d1140397e42d6dd2621639821d7a9c/?size=200",
		"active": true,
		"name": "Neill Brookman",
		"mail": "neill.brookman@auth0.com",
		"title": "Head of Pre-sales, EMEA",
		"quote": "Husband, father of 3 and technology geek",
		"social": {
			"twitter": "https://twitter.com/Neill_Brookman"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b6b7b936f75e1eeba8aeef306db1f764/?size=200",
		"active": true,
		"name": "José Luis Diaz",
		"mail": "jose.luis.diaz@auth0.com",
		"title": "Engineer",
		"quote": "Programmer who used to be a sysadmin. Linux advocate, open source enthusiast.",
		"social": {
			"git": "https://github.com/joseluisdiaz",
			"twitter": "https://twitter.com/__joselo"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/248cf82624c544843dfdfdf904866b77/?size=200",
		"active": true,
		"name": "Toon De Coninck",
		"mail": "toon@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Developer, soccer player, trance lover",
		"social": {
			"git": "https://github.com/dctoon",
			"twitter": "https://twitter.com/toondc"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/72956a2f6ee6c25ad00d194cf7543719/?size=200",
		"active": true,
		"name": "Luís Deschamps Rudge",
		"mail": "luis.rudge@auth0.com",
		"title": "Front End Engineer",
		"quote": "Father, Developer and former music producer. Trying not to mix spaces and tabs",
		"social": {
			"git": "https://github.com/luisrudge",
			"twitter": "https://twitter.com/luisrudge"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ee4caa0a15026c9d769038be3b87bd04?s=200",
		"active": true,
		"name": "Chris Dukelow",
		"mail": "duke@auth0.com",
		"title": "CFO",
		"quote": "Startup Junkie, Winemaker, Sailor"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/76ea40cbf67675babe924eecf167b9b8/?size=200",
		"active": true,
		"name": "Bruno Simões Krebs",
		"mail": "bruno.krebs@auth0.com",
		"title": "Technical Writer",
		"quote": "Software developer passionate about open source.",
		"social": {
			"git": "https://github.com/brunokrebs",
			"twitter": "https://twitter.com/brunoskrebs"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b10474060eb9bc9334e41ad14ac2b73c/?size=200",
		"active": true,
		"name": "Ariel Schapiro",
		"mail": "ari@auth0.com",
		"title": "Business Manager, Customer Success",
		"quote": "Tech lover, idealist, obsessed with balance and disruption...and with my wife and kids.",
		"social": {
			"twitter": "https://twitter.com/aschapiro"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/3e8ce75cfe7c53f13715df274f63e129?s=200",
		"active": true,
		"name": "Richard Dowinton",
		"mail": "richard.dowinton@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Software generalist. Always looking to help and influence others."
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/donna-3bb1527770.png",
		"active": true,
		"name": "Donna Joyce",
		"title": "Corporate Account Executive, Sales",
		"quote": "Living life to the full - Passionate Sales Maker ❤️ - Mother of a teenage boy - Partner of a gorgeous man - Horse/Dog & Gin Lover",
		"social": {
			"twitter": "https://twitter.com/DJAuth0"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/7bf321b5e1b136a7c14e747ab52735f5?s=200",
		"active": true,
		"name": "Drew Fyock",
		"mail": "drew@auth0.com",
		"title": "Engineer",
		"quote": "Not just any geek off the street 🤓",
		"social": {
			"git": "https://github.com/fyockm",
			"twitter": "https://twitter.com/drewfyock"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/15c3af947c265684728a95a5ef5046ff?s=200",
		"active": true,
		"name": "Jonathan King",
		"mail": "jonno@auth0.com",
		"title": "Sr. Director World Wide Operations",
		"quote": "Renaissance man. Football Devotee. Soirée Advocate",
		"social": {
			"twitter": "https://twitter.com/jonnoking",
			"git": "https://github.com/jonnoking"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/dc2976306e783b9a00bf27785a8258f7?s=80",
		"active": true,
		"name": "Esteban Lopez",
		"mail": "esteban.lopez@auth0.com",
		"title": "Engineer",
		"quote": "Coder, technology geek, metal lover",
		"social": {
			"git": "https://github.com/estebanlopez"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/e9538d45ed17002f1ebf07258f6663e0?s=200",
		"active": true,
		"name": "Brett Hazen",
		"mail": "brett@auth0.com",
		"title": "Engineer",
		"quote": "Dad 👪. Developer dude 💻. Distancer 🏃. Drinker of distinguished draughts 🍺. Dedicated to FP λ.",
		"social": {
			"twitter": "https://twitter.com/_javajolt",
			"git": "https://github.com/javajolt"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/cdb9ce88680d48bb5e5988e84fbfb2e5?s=200",
		"active": true,
		"name": "Santiago Canti",
		"mail": "santiago.canti@auth0.com",
		"title": "Engineer",
		"quote": "Problem solver, music lover, animals advocate",
		"social": {
			"git": "https://github.com/santiagocanti"
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/people.json
// module id = 369
// module chunks = 0